export const getMutationType = (fieldName, mutations = {}) => { // eslint-disable-line import/prefer-default-export, max-len
  let mutationType = null

  if (fieldName in mutations) {
    mutationType = mutations[fieldName]
  }

  return mutationType
}
